import React, { useEffect, useState } from 'react';
import slid1 from '../../../assets/images/Slide img/AdobeStock_223290240-1-scaled.jpeg'; 
import slid2 from '../../../assets/images/Slide img/amazon-paneuropeen-1.jpg';
import slid3 from '../../../assets/images/Slide img/e-commerce-saudi-min-scaled.jpg';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import MultiDropdown from '../../../components/Buttons/MultiDropdown'
import Editlabel from '../../../components/Buttons/Editlabel/Editlabel'
import Bannerbutton from '../../../components/Buttons/Bannerbutton/Bannerbutton'
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { FaPlay } from "react-icons/fa6";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import Slidshow from '../../../components/Slidshow/Slideshow';


export const Banner = () => {
  const [current, setCurrent] = useState(0);
  const [showPreview, setShowPreview] = useState(false);
   

  const images = [slid1, slid2, slid3];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [images.length]);

  console.log(showPreview)

  return (
   
    <div className=' min-h-min mt-11 mb-8 '>
    <div className='flex p-2 justify-center'>
  <h1
    className="text-2xl mt-1 cursor-pointer"
    data-tooltip-id="bannerTooltip"
    data-tooltip-html={`
      <div class='tooltip-bubble'>
        <div class='tooltip-content'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
          Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
        </div>
        <div class='tooltip-tail'></div>
      </div>
    `}
  >
    <HiOutlineInformationCircle />
  </h1>
  <h1 className='font-semibold text-2xl ml-2'>Banner Preview</h1>

  <Tooltip
    id="bannerTooltip"
    place="bottom"
    offset={10}
    className="!bg-transparent z-30 ms-28 !p-0 !rounded-none"
  />
</div>


   <div>
    <Slidshow/>
   </div>

    <div className='mt-2'>
   <MultiDropdown/>
   </div>
   <div className='mt-2'>
    <Editlabel/>
   </div>
   <div className='mt-2'>
    <Bannerbutton/>
   </div>
   
    </div>
   
  );
};
